import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Entrás a una habitación y no recordás a qué fuiste. Tres veces al día.', 'La palabra está en la punta de la lengua y no aparece. En plena conversación.', 'Leés dos párrafos y tenés que volver a empezar porque la mente se fue.', 'A las 3 de la tarde la cabeza pesa como si fuera de piedra.', 'Dormís 8 horas y amanecés agotada como si no hubieras descansado.', 'Llevás años tomando suplementos y probando cosas. La niebla sigue.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-154">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-155" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-156">
        <div className="max-w-4xl mx-auto" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-158">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif]" data-id="element-159">
              ¿Cuántos años más vas a creer que esto es la edad?
            </h2>
            <p className="text-xl text-gray-300 mb-4" data-id="element-160">
              Sos inteligente. Siempre lo fuiste.
            </p>
            <p className="text-xl text-gray-300 mb-4" data-id="element-161">
              Pero algo cambió. Y el médico te dijo lo de siempre:
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-162">
              "Es el estrés. Es la menopausia. Es normal a tu edad."
            </p>
            <p className="text-xl text-gray-300 mt-4" data-id="element-163">
              No es la edad. Es el intestino que alimenta tu cerebro.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-164">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-165">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-166" />
                <p className="text-lg text-gray-200" data-id="element-167">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-168">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-169">
              El problema no está en tu cerebro. Está en el intestino que lo
              alimenta.
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}